import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UserCredentialsForm from '../UserCredentialsForm';
import {
  setUsersData,
  completeUserCredentialsTask,
  cancelUserCredentialsTask
} from '../../../redux/actions/rootAction';
import { selectPreparedState } from '../../../redux/selectors/preparedState';
import {
  buildUsersData,
  applyCustomRecipientsData,
  usersDataOk
} from '../../helpers/userFieldsData';
import {
  isUserCredentialsProcessing,
  isUserCredentialsEmbedInCaller
} from '../../../redux/userCredentialsTask';
import {
  reportCredentialsCancelled,
  reportCredentialsDone
} from '../userCredentialsSideEffects';

function UserCredentialsOverlay(props) {
  const {
    userCredentialsTask,
    completeButtonLabel,
    region,
    setUsersData: setUsersDataAction,
    completeUserCredentialsTask: completeCredentials,
    cancelUserCredentialsTask: cancelCredentials
  } = props;

  const awaitingCredentials = isUserCredentialsProcessing(userCredentialsTask);
  const embedInCaller = isUserCredentialsEmbedInCaller(userCredentialsTask);
  // QES provider modal owns the UI — do not open a second popup
  const showOverlay = awaitingCredentials && !embedInCaller;

  const customRecipientsDataSource =
    userCredentialsTask?.customRecipientsDataSource;
  const usersData = applyCustomRecipientsData(
    buildUsersData(props),
    customRecipientsDataSource
  );

  const cancelForm = () => {
    if (!awaitingCredentials) {
      return;
    }
    reportCredentialsCancelled();
    cancelCredentials();
  };

  const onFormDone = () => {
    reportCredentialsDone();

    setTimeout(() => {
      // Form already committed draft via setUsersData on Send click
      completeCredentials();
    }, 300);
  };

  return (
    <UserCredentialsForm
      key="user_credentials_overlay"
      popupId="user_credentials_overlay"
      sendTitle={userCredentialsTask?.customTitle}
      completeButtonLabel={completeButtonLabel}
      region={region}
      setUsersData={setUsersDataAction}
      usersData={usersData}
      usersDataOk={usersDataOk}
      opened={showOverlay}
      onCancel={cancelForm}
      onClick={onFormDone}
    />
  );
}

UserCredentialsOverlay.propTypes = {
  userCredentialsTask: PropTypes.object,
  completeButtonLabel: PropTypes.string,
  region: PropTypes.string,
  usersData: PropTypes.array,
  requestedDocuments: PropTypes.array,
  preparedFormsData: PropTypes.object,
  preparedFormsStructures: PropTypes.object,
  qesValueInheritance: PropTypes.object,
  embeddingFieldsInheritance: PropTypes.object,
  recipientConditions: PropTypes.array,
  setUsersData: PropTypes.func,
  completeUserCredentialsTask: PropTypes.func,
  cancelUserCredentialsTask: PropTypes.func
};

const mapStateToProps = state => {
  const {
    requestedDocuments,
    preparedFormsData,
    preparedFormsStructures
  } = selectPreparedState(state);

  return {
    userCredentialsTask: state.userCredentialsTask,
    completeButtonLabel: state.completeButtonLabel,
    region: state.region,
    usersData: state.usersData,
    requestedDocuments,
    preparedFormsData,
    preparedFormsStructures,
    qesValueInheritance: state.qesValueInheritance,
    embeddingFieldsInheritance: state.embeddingFieldsInheritance,
    recipientConditions: state.recipientConditions
  };
};

const mapDispatchToProps = dispatch => ({
  setUsersData: value => dispatch(setUsersData(value)),
  completeUserCredentialsTask: () => dispatch(completeUserCredentialsTask()),
  cancelUserCredentialsTask: () => dispatch(cancelUserCredentialsTask())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCredentialsOverlay);
